import React, {Component} from 'react';
import * as customers from 'customers/actions/customers';
import {connect} from 'react-redux';
import {DetailContainer} from 'customers/DetailContainer';
import autobind from 'autobind-decorator';
import Loading from 'apa/components/Loading';
import {NavLink} from 'react-router-dom'
import {Button, Modal, ModalHeader, ModalBody} from 'reactstrap'
import Dialog from 'apa/containers/Dialog';
import { BaseUrl } from '../BaseUrl/BaseUrl';


export const TrainingOverviewLink = (props) => (
    <Button href={`/training/overview/${props.uuid}`} target='_blank' rel='noreferrer' color='primary'>
        <i className='fa fa-edit'> </i>
    </Button>
)

@connect(
    state => {
        return {
            customers: state.customers,
            auth: state.apa
        }
    },
    dispatch => {
        return {
            fetchCustomer: (customer_id, callback) => {
                dispatch(customers.fetchCustomer(customer_id, callback))
            }
        }
    }
)
export default class TrainingList extends Component {


    constructor(props) {
        super(props);
        this.state = {
            isSubmitting: false,
            isLoading: true,
            customer: null,
            deleteModal: false,
            trainingId: null,
            trainingList:[]
        };
    }

    componentDidMount() {
        const id = this.props.match.params.id;
        this.props.fetchCustomer(id, customer => this.setState({isLoading: false, customer: customer}))
    }

    @autobind
    handleChange(event) {
        const target = event.target;
        const name = target.name;
        const value = target.value;
        this.setState({
            customer: {
                ...this.state.customer,
                [name]: value
            }
        })
    }

    @autobind
    onSubmit(event) {
        event.preventDefault();
        this.setState({
            isSubmitting: true
        });
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Token ${this.props.auth.token}`
        };
        const body = JSON.stringify(this.state.customer);
        fetch(
            `/api/customers/${this.props.match.params.id}/`,
            {headers, method: 'PATCH', body}
        ).then(res => res.json())
            .then(
                customer => this.setState({isSubmitting: false, customer: customer})
            )

    }

    render() {
        const id = this.props.match.params.id;
        const customer = this.state.customer;
        if (this.state.isLoading)
            return <Loading/>
        const trainingList = customer.trainings;
        const toggleDeleteModal = (id) => {
            console.log(id)
            this.setState({
                deleteModal: true,
                trainingId: id
            })
        }
        const toggle = () => this.setState({deleteModal: !this.state.deleteModal});
        const confirm = () => {
            const accessToken = this.props.auth.token;
            const uuid = this.state.trainingId
            const headers = {
                'Authorization': `Token ${accessToken}`,
                'Content-Type': 'application/json'
            };
            fetch(
                `${BaseUrl}/api/customers/training/${uuid}/archive/`,
                {headers, method: 'POST', body: JSON.stringify({
                    uuid: uuid
                    })}
            ).then(
                () => {
                    toggle()
                    window.location.reload()
                }
            )
        }
        return (
            <DetailContainer id={id}>
                <h1>{customer.name}</h1>
                <NavLink className='btn btn-primary' to='training/new'>Neue Schulung anlegen</NavLink>
                <table className='table'>
                    <tbody>
                    {
                        trainingList.map(
                            (training, idx) => (
                                <tr key={`training_${idx}`}>
                                    <td>
                                        {training?.name}
                                    </td>
                                    <td>
                                        {training?.start_at} - {training?.end_at}
                                    </td>
                                    <td>
                                        <TrainingOverviewLink uuid={training?.uuid} />
                                        <Button color='danger' onClick={() => toggleDeleteModal(training?.uuid)}>
                                            <i className='fa fa-trash'> </i>
                                        </Button>
                                    </td>
                                </tr>
                            )

                        )
                    }
                    </tbody>
                </table>
                <Dialog
                    isOpen={this.state.deleteModal}
                    toggle={toggle}
                    confirm={confirm}
                    title={'Schulung löschen'}
                >
                  Wirklich löschen?
                </Dialog>
            </DetailContainer>
        )
    }
}

